<template>
	<div @click="clickQr" :style="sizeStyle" class="download-qr-container" :class="{pointer: withDownloadButton}">
		<div ref="qr-container" class="qr-container"></div>
		<AppInPlaceCloud @close-cloud="closeCloud" v-if="withDownloadButton" v-show="currQr" top :active="activeDownloadQrCloud">
			<AppButton @click="clickDownloadQr" icon-left="icon-download-secondary" :text="getString('download_qr')" />
			<a ref="download-link" :download="'qrcode-'+name+'.png'" :href="downloadLink" class="invisible"></a>
		</AppInPlaceCloud>
	</div>
</template>

<script>
import AppInPlaceCloud from "@/shared/components/AppInPlaceCloud.vue";
import AppButton from "@/shared/components/AppButton.vue";

import {useLanguageStore, useScriptStore} from "@/shared/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let scriptStore = useScriptStore();
		return {getString: languageStore.getString, loadScript: scriptStore.loadScript}
	},
	name: "AppQrImage",
	components: {AppButton, AppInPlaceCloud},
	props: {
		value: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: 'download'
		},
		size: {
			type: Number,
			default: 170
		},
		withDownloadButton: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			currQr: null,
			downloadLink: null,
			qrLoadTimeout: null,
			loadedQrLibrary: false,
			closeDownloadCloudListener: null,
			activeDownloadQrCloud: false,
		}
	},
	computed: {
		sizeStyle() {
			return '--qr-size: ' + this.size + 'px';
		}
	},
	methods: {
		setQrImage() {
			let finalFunction = ()=>{
				if(this.currQr) { this.currQr.clear(); }
				if(this.$refs['qr-container']) {
					this.$refs['qr-container'].innerHTML = '';
					this.currQr = new QRCode(this.$refs['qr-container'], {
						text: this.value,
						width: this.size - 50,
						height: this.size - 50,
						onRenderingEnd: this.setDownloadLink
					});
				}
			}
			if(this.loadedQrLibrary) {
				finalFunction();
			} else {
				clearTimeout(this.qrLoadTimeout);
				this.qrLoadTimeout = setTimeout(()=>{
					this.setQrImage();
				}, 100);

			}
		},
		clickQr() {
			if(!this.closeDownloadCloudListener) {
				this.activeDownloadQrCloud = true;
				this.closeDownloadCloudListener = (e)=>{
					if(e.target && !e.target.classList.contains('download-qr-container') && !this.elementIsInQr(e.target)) {
						this.closeDownloadCloudListener = null;
						if(this.activeDownloadQrCloud) {
							this.activeDownloadQrCloud = false;
						}
					} else {
						document.addEventListener('click', this.closeDownloadCloudListener, {once: true});
					}
				}
				document.addEventListener('click', this.closeDownloadCloudListener, {once: true});
			}
		},
		closeCloud() {
			this.activeDownloadQrCloud = false;
			document.removeEventListener('click', this.closeDownloadCloudListener);
		},
		elementIsInQr(element) {
			let maxIterations = 20;
			let currentIterations = 0;
			while (element.parentElement && currentIterations <= maxIterations) {
				if(element.classList.contains('download-qr-container')) {
					return true;
				}
				element = element.parentElement;
				currentIterations++;
			}
			return false;
		},
		setDownloadLink() {
			let qrChildren = this.$refs && this.$refs['qr-container'] && this.$refs['qr-container'].children;
			if (qrChildren && qrChildren.length === 2) {
				this.downloadLink = qrChildren[1].getAttribute("src");
			}
		},
		clickDownloadQr() {
			if(this.downloadLink) {
				this.$refs['download-link'].click();
			}
		},
	},
	mounted() {
		this.loadScript("qrs", () => {
			this.loadedQrLibrary = true;
			this.setQrImage();
		});
	},
	watch: {
		value() {
			this.setQrImage();
		},
		size() {
			this.setQrImage();
		}
	}
}
</script>

<style lang="scss" scoped>
:root {
	--qr-size: 200px;
}
.download-qr-container {
	@include centered;
	height: var(--qr-size);
	width: var(--qr-size);
	position: relative;
	background: var(--color-txt-white);
	border-radius: 13px;
	box-shadow: 0 1px 2px var(--color-box-shadow-3);

	.qr-container {
		display: block;
		height: calc(var(--qr-size) - 20px);
		width: calc(var(--qr-size) - 20px);
		padding: 10px;

		:deep(img){
			width: 100%;
			pointer-events: none;
			@include noSelect;
		}
	}
}
a.invisible {
	position: absolute;
	z-index: -1;
	opacity: 0;
	height: 0;
	width: 0;
}
</style>